import Vue from 'vue'
import VueRouter from 'vue-router'
import { getPublisherList } from '@/server'

const Layout = () => import(/* webpackChunkName: "layout" */ '@/layout')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard')
const OfferDetail = () => import(/* webpackChunkName: "offerDetail" */ '@/views/OfferDetail')
const OfferList = () => import(/* webpackChunkName: "offerDetail" */ '@/views/OfferList')
const OfferRevenue = () => import(/* webpackChunkName: "offerDetail" */ '@/views/OfferRevenue')
const Login = () => import(/* webpackChunkName: "Login" */ '@/views/Login/login.vue')
const CpsOfferRevenue = () => import(/* webpackChunkName: "cpsOfferRevenue" */ '@/views/CpsOfferRevenue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Layout,
    redirect: {
      name: 'Dashboard'
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'offerDetail',
        name: 'OfferDetail',
        component: OfferDetail
      },
      {
        path: 'OfferRevenue',
        name: 'OfferRevenue',
        component: OfferRevenue
      },
      {
        path: 'offerList',
        name: 'OfferList',
        component: OfferList
      },
      {
        path: 'cpsOfferRevenue',
        name: 'CpsOfferRevenue',
        component: CpsOfferRevenue
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加路由守卫
router.beforeEach(async (to, from, next) => {
  const { data } = await getPublisherList()
  // 修改判断逻辑，将novaInstallUsers单独定义
  const novaInstallUsers = [1013043, 1013117]
  const isCpsUser = data.code === 200 && 
    data.data.nicknames && 
    data.data.nicknames.length > 0 && 
    [1013043, 1013117, 1011633].includes(Number(data.data.nicknames[0].publisherId))

  // CPS用户只能访问CPS Revenue页面
  if (isCpsUser) {
    if (to.name === 'CpsOfferRevenue') {
      next()
    } else if (to.name === 'login') {
      next()
    } else {
      next({ name: 'CpsOfferRevenue' })
    }
  } else {
    // 非CPS用户不能访问CPS Revenue页面
    if (to.name === 'CpsOfferRevenue') {
      next('/dashboard')
    } else {
      next()
    }
  }
})

export default router
